import { defineStore } from 'pinia'
import { getCategoryDetailsById } from '@/services/categoryService'
import { getContentPage, getNews } from '@/services/contentService'
import { getBannerDetailsBySlug, getBanners } from '@/services/bannerService'
import { getProjectListHome } from '@/services/projectService'

export const useHomeContentStore = defineStore('home', {
  state: () => ({
    contents: {
      about: {},
      vision: {},
      mission: {},
      project: {},
      services: {},
      thinker: {},
      safety: {},
      leadership: {},
      news: {},
      ourClient: {},
      projects: [],
      banners: [],
      leaderships: [],
      newsList: [],
      clients: [],
      contacts: [],
      previewBanner: {}
    },
    loading: false,
    error: null
  }),

  actions: {
    async fetchContentPage() {
      this.loading = true
      this.error = null

      try {
        const baseUploadURL = process.env.VUE_APP_API_URL;
        const aboutContent = await getContentPage('Home', 'Who We Are')
        const visionContent = await getContentPage('Home', 'Our Vision')
        const missionContent = await getContentPage('Home', 'Our Mission')
        const projectContent = await getContentPage('Home', 'Projects')
        const servicesContent = await getContentPage('Home', 'Services')
        const thinkerContent = await getContentPage('Home', 'Thinker')
        const safetyContent = await getContentPage('Home', 'Safety')
        const leadershipContent = await getContentPage('Home', 'Leadership')
        const leadershipList = await getContentPage('Home', 'Item Leadership')
        const newsContent = await getContentPage('Home', 'News')
        const newsLists = await getNews(1, 10) //nanti di buat db
        const ourClientContent = await getContentPage('Home', 'Our Client')
        const ourClientList = await getContentPage('Home', 'Item Client')
        const bannerList = await getBanners()
        const contactList = await getContentPage('Home', 'Item Contact')
        const projectList = await getProjectListHome()

        const mapLeadershipList = await Promise.all(
          leadershipList.map(async item => ({
            ...item,
            image: item.banner
              ? baseUploadURL + item.banner.uploadFile
              : null,
          }))
        )

        const mapProjectList = await Promise.all(
          projectList.docs.map(async item => ({
            ...item,
            image: item.coverBanner
              ? baseUploadURL + item.coverBanner.uploadFile
              : null,
            thumbs: item.thumbnails
              ? baseUploadURL + item.thumbnails.uploadFile
              : null,

            categoryId: {
              ...item.categoryId,

              parentId:
                item?.categoryId?.parentId !== null
                  ? await getCategoryDetailsById(item.categoryId.parentId)
                  : null
            }
          }))
        )

        // const titleTextAlign = item.titleTextAlign === null ? ;
        // const titleFontSize = "";
        // const titleFontColor = "";
        // const titleBackgroundColor = "";
        // const titleFontFamily = "";
        // const titlePosition = "";

        const mapBannerList = await Promise.all(
          bannerList.map(async item => ({
            ...item,
            banner: item?.banner
              ? baseUploadURL + item?.banner?.uploadFile
              : null,
            titleStyles: {
              textAlign : item.titleAlign || "",
              fontSize : item.titleFontSize || "",
              color : item.titleFontColor || "",
              backgroundColor : item.titleBackgroundColor || "",
              fontFamily : item.titleFontFamily || "",
            },
            buttonStyles: {
              fontSize : item.buttonTitleFontSize || "",
              color : item.buttonTitleFontColor || "",
              backgroundColor : item.buttonTitleBackgroundColor || "",
              borderColor : item.buttonTitleBackgroundColor || "",
            },
            descriptionsStyles: {
              textAlign : item.descriptionsAlign || "",
              fontSize : item.descriptionsFontSize || "",
              color : item.descriptionsFontColor || "",
              backgroundColor : item.descriptionsBackgroundColor || "",
              fontFamily : item.descriptionsFontFamily || "",
            }
          }))
        )

        // console.log(mapBannerList)

        const mapourClientList = await Promise.all(
          ourClientList.map(async item => ({
            ...item,
            image: item.banner
              ? baseUploadURL + item.banner.uploadFile
              : null,
          }))
        )

        
        const mapNewsLists = await Promise.all(
          newsLists.map(async item => ({
            ...item,
            image: item.banner
              ? baseUploadURL + item.banner.uploadFile
              : null,
          }))
        )
        
        this.contents.about = aboutContent.length > 0 ? aboutContent[0] : null
        this.contents.vision = visionContent.length > 0 ? visionContent[0] : null
        this.contents.mission = missionContent.length > 0 ? missionContent[0] : null
        this.contents.project = projectContent.length > 0 ? projectContent[0] : null
        this.contents.services = servicesContent.length > 0 ? servicesContent[0] : null
        this.contents.thinker = thinkerContent.length > 0 ? thinkerContent[0] : null
        this.contents.safety = safetyContent.length > 0 ? safetyContent[0] : null
        this.contents.leadership = leadershipContent.length > 0 ? leadershipContent[0] : null
        this.contents.leaderships = mapLeadershipList
        this.contents.news = newsContent.length > 0 ? newsContent[0] : null
        this.contents.newsList = mapNewsLists
        this.contents.ourClient = ourClientContent.length > 0 ? ourClientContent[0] : null
        this.contents.clients = mapourClientList
        this.contents.banners = mapBannerList
        this.contents.projects = mapProjectList
        this.contents.contacts = contactList

        // console.log(this.contents.about)
        // console.log(this.contents.vision)
        // console.log(this.contents.mission)
        // console.log(this.contents.project)
        // console.log(this.contents.services)
        // console.log(this.contents.thinker)
        // console.log(this.contents.safety)
        // console.log(this.contents.leadership)
        // console.log(this.contents.news)
        // console.log(this.contents.ourClient)
        // console.log(this.contents.banners)
        // console.log(this.contents.leaderships)
        // console.log(this.contents.projects)
        // // console.log(projectList)
        // console.log(this.contents.newsList)
        // console.log(this.contents.clients)
        // console.log(this.contents.contacts)
      } catch (err) {
        this.error = err.message
      } finally {
        this.loading = false
      }
    },
    async fetchPreviewPage(slug) {
      this.loading = true
      this.error = null

      try {
        const baseUploadURL = process.env.VUE_APP_API_URL;
        const previewBannerContent = await getBannerDetailsBySlug(slug)
        console.log(slug)
        console.log(previewBannerContent)
        previewBannerContent.image = previewBannerContent.banner
          ? baseUploadURL + previewBannerContent.banner.uploadFile
          : null;

        
        this.contents.previewBanner = previewBannerContent

        console.log(this.contents.previewBanner)
      } catch (err) {
        this.error = err.message
      } finally {
        this.loading = false
      }
    }
  }
})